import axiosInstance from 'app/modules/shared/api/axiosInstance';

export const DynamicDashboardsAPI = {
    // getUserDashboards: (company, factory) => {
    //     return axiosInstance.get(
    //         `${company}/${factory}/dynamic_dashboards/get_user_dashboards`
    //     );
    // },
    // API call disabled: return dummy data
    getUserDashboards: (company, factory) => {
        return Promise.resolve({ data: [] });
    },
};
